import React from 'react';
import { Grid as MuiGrid, GridProps } from '@mui/material';

// Type-safe Grid component that works with current MUI version
export const Grid = React.forwardRef<any, GridProps & { 
  item?: boolean; 
  container?: boolean; 
  xs?: number | boolean;
  sm?: number | boolean;
  md?: number | boolean;
  lg?: number | boolean;
  xl?: number | boolean;
}>((props, ref) => {
  // Just pass all props directly to MuiGrid - let MUI handle the props
  return <MuiGrid ref={ref} {...props as any} />;
});

Grid.displayName = 'Grid';

export default Grid;